module.exports = __webpack_public_path__ + "static/media/search.71e37488.png";